import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronDown = (props) => {
    return (
        <Icon
            viewBox="0 0 12 12"
            fill="none"
            {...props}
            data-testid="chevron-down"
            aria-hidden="true"
        >
            <path
                id="arrow"
                d="M3 4.5L6 7.5L9 4.5"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default ChevronDown
